// Module
import { APP_INITIALIZER, DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { AppRoutingModule } from './app-routing.module';
import { GlobalModule } from './global/global.module';
import { CoreModule } from './core/core.module';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './shared';
import it from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
// Component
import { AppComponent } from './app.component';
// Angular material
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// Angular fire
// Translate
import { I18nModule } from './i18n/i18n.module';
import { APP_DEFAULT_LANGUAGE } from '@global/constants';
import { MaintenanceService } from '@core/services/maintenance/maintenance.service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ChatConfigVisibilityService } from '@core/services/chat-config-visibility/chat-config-visibility.service';

export function get_app_maintenance(maintenanceService: MaintenanceService): any {
  return async () => maintenanceService.getMaintenance({});
}

export function get_app_chatConfigVisibility(chatConfigVisibilityService: ChatConfigVisibilityService): any {
  return async () => chatConfigVisibilityService.getChatConfigVisibility({});
}

registerLocaleData(it);

@NgModule({
  declarations: [AppComponent],
  imports: [
    IonicModule.forRoot(),
    AppRoutingModule,
    BrowserModule,
    CoreModule,
    SharedModule,
    GlobalModule.forRoot(),
    I18nModule.forRoot({
      resources: [{ prefix: './assets/i18n/' }],
    }),
    BrowserAnimationsModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: LOCALE_ID, useValue: APP_DEFAULT_LANGUAGE },
    { provide: MAT_DATE_LOCALE, useValue: APP_DEFAULT_LANGUAGE },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    {
      provide: APP_INITIALIZER,
      useFactory: get_app_maintenance,
      deps: [MaintenanceService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: get_app_chatConfigVisibility,
      deps: [ChatConfigVisibilityService],
      multi: true,
    },
  ],
})
export class AppModule {}
